import {
  SET_TOOLBOX_EXPANDED,
  SET_TOOLBOX_EXPANDED_CASE,
  SET_TOOLBOX_EXPANDED_SLIDE
} from '@/store/mutation-types'

export const namespaced = false
export const state = {
  toolboxOpen: true,
  caseToolboxOpen: true,
  slideToolboxOpen: false,
  backgroundColor: 'white'
}
export const mutations = {
  [SET_TOOLBOX_EXPANDED](state, open) {
    state.toolboxOpen = open
    if (!open) {
      state.caseToolboxOpen = false
      state.slideToolboxOpen = false
    }
  },
  [SET_TOOLBOX_EXPANDED_CASE](state, open) {
    if (open) {
      state.caseToolboxOpen = true
      state.slideToolboxOpen = false
      state.toolboxOpen = true
    } else {
      state.caseToolboxOpen = false
      state.slideToolboxOpen = false
      state.toolboxOpen = false
    }
  },
  [SET_TOOLBOX_EXPANDED_SLIDE](state, open) {
    if (open) {
      state.slideToolboxOpen = true
      state.caseToolboxOpen = false
      state.toolboxOpen = true
    } else {
      state.slideToolboxOpen = false
      state.caseToolboxOpen = false
      state.toolboxOpen = false
    }
  },
  ['SET_BACKGROUND_COLOR'](state, color) {
    state.backgroundColor = color
  }
}
export const actions = {
  [SET_TOOLBOX_EXPANDED]({ commit }, open) {
    commit(SET_TOOLBOX_EXPANDED, open)
  },
  [SET_TOOLBOX_EXPANDED_CASE]({ commit }, open) {
    commit(SET_TOOLBOX_EXPANDED_CASE, open)
  },
  [SET_TOOLBOX_EXPANDED_SLIDE]({ commit }, open) {
    commit(SET_TOOLBOX_EXPANDED_SLIDE, open)
  },
  ['SET_BACKGROUND_COLOR']({ commit }, color) {
    commit('SET_BACKGROUND_COLOR', color)
  }
}
